import {getRequest} from "./getRequest";
import { loginRequest, postImageRequest, postRequest } from "./postRequest";
 
// if run start process.env.NODE_ENV == "development";
// if run build process.env.NODE_ENV == "production";

// let serverURL = "https://api.ubtcambodia.com";

let serverURL = "https://dev.ubtcambodia.com";



// let serverURL = "http://192.168.1.181:4000";

// let serverURL = "https://5600-45-201-206-199.ngrok-free.app";

if (process.env.NODE_ENV == "production") {
    // always fix with product url
    serverURL = "https://api.ubtcambodia.com"
  } 

let api = serverURL + "/admin"

let userRoute = api + "/users/";
let userTestResultRoute = api + "/quiz_result/";
let roleRoute = api + "/role/";
let reportRoute = api + "/report/";
let questionRoute = api + "/quiz/";
let episodeRoute = api + "/episodes/";
let categoryRoute = serverURL + "/admin/category/";
let blindTestRoute = serverURL + "/admin/blind_test/";
let ReasontRoute = serverURL + "/admin/apply_leave_reason/";
let ApplyLeaveRoute = serverURL + "/admin/apply_leave/";
let dailyTaskRoute = serverURL + "/admin/task/";
let folderRoute = serverURL + "/admin/folder/";
let permissionRoute = serverURL + "/admin/group_permission/";
let branchRoute = serverURL + "/admin/school_branch/";
let wordLishRoute = serverURL + "/admin/vocab/";
let topicRoute = serverURL + "/admin/vocab_topic/";
let wordTypeRoute = serverURL + "/admin/vocab_folder/";
let classRoute = serverURL + "/admin/class/";
let newsRoute = serverURL + "/admin/news/";
let settingRoute = serverURL + "/admin/setting/";
let adminUpload = serverURL + "/admin/upload/";

let route = {
    getStorageInfo: api + "/storage/get",

    build_update : api + "/backend/gitpull",
    

    // user
    getAllUsers: userRoute + "get/all",
    getOneUser: userRoute + "get/one",
    postUser: userRoute + "create_or_update",
    resetUser: userRoute + "reset_device",
    deleteUser: userRoute + "delete",
    blockUser: userRoute + "block",

    // user test result
    getAllUsersTestResult: userTestResultRoute + "get/all",
    getOneUserTestResult: userTestResultRoute + "get/one",

    // question
    getAllQuestions: questionRoute + "get/all",
    getOneQuestion: questionRoute + "get/one",
    postQuestion: questionRoute + "create_or_update",
    updateTestQuestion: questionRoute + "test/update",
    deleteQuestion: questionRoute + "delete",
    // publicVideo: videoRoute + "public",
    postEpisode: episodeRoute + "create_or_update",
    getAllCategory: categoryRoute + "get/all",
    getOneCategory: categoryRoute + "get/one",
    postOneCategory: categoryRoute + "create_or_update",

    // blind test
    getAllBlindTest: blindTestRoute + "get/all",
    getOneBlindTest: blindTestRoute + "get/one",
    postOneBlindTest: blindTestRoute + "create_or_update",
    deleteBlindTest: blindTestRoute + "delete",

    // Reason
    getAllApplyLeaveReason: ReasontRoute + "get/all",
    getOneApplyLeaveReason: ReasontRoute + "get/one",
    postOneApplyLeaveReason: ReasontRoute + "create_or_update",
    deleteApplyLeaveReason: ReasontRoute + "delete",

    // Apply Leave
    getAllApplyLeave: ApplyLeaveRoute + "get/all",
    getOneApplyLeave: ApplyLeaveRoute + "get/one",
    postOneApplyLeave: ApplyLeaveRoute + "update",
    deleteApplyLeave: ApplyLeaveRoute + "delete",

    // Daily Task
    getAllDailyTask: dailyTaskRoute + "get/all",
    getOneDailyTask: dailyTaskRoute + "get/one",
    postOneDailyTask: dailyTaskRoute + "create_or_update",
    deleteDailyTask: dailyTaskRoute + "delete",
    approveDailyTask: dailyTaskRoute + "approve",

    // folder
    getAllFolder: folderRoute + "get/all",
    getOneFolder: folderRoute + "get/one",
    postOneFolder: folderRoute + "create_or_update",
    deleteFolder: folderRoute + "delete",
    
    // class
    getAllClass: classRoute + "get/all",
    getOneClass: classRoute + "get/one",
    postOneClass: classRoute + "create_or_update",
    deleteClass: classRoute + "delete",

    // news
    getAllNews: newsRoute + "get/all",
    getOneNews: newsRoute + "get/one",
    postOneNews: newsRoute + "create_or_update",

    // setting
    getTerm: settingRoute + "get",
    // getAbout: settingRoute + "about_us/get",
    getAbout: settingRoute + "get",
    updateSetting: settingRoute + "update",
    login: api + "/login",
    // report
    getUsersReport: reportRoute + "users",
    getVideosReport: reportRoute + "videos",
    getSellReport: reportRoute + "sale",

    // role
    getUserRole: roleRoute + "user",
    createOrUpdatePermission: roleRoute + "permission/create_or_update",
    createOrUpdateRole: roleRoute + "create_or_update",
    getAllRole: roleRoute + "all",

    // Branch
    deleteBranch: branchRoute + "delete",
    getAllBranch: branchRoute + "get/all",
    getOneBranch: branchRoute + "get/one",
    postOneBranch: branchRoute + "create_or_update",

    // Word List
    deleteWordList: wordLishRoute + "delete",
    getAllWordList: wordLishRoute + "get/all",
    getOneWordList: wordLishRoute + "get/one",
    postOneWordList: wordLishRoute + "create_or_update",

    // Word Type
    deleteWordType: wordTypeRoute + "delete",
    getAllWordType: wordTypeRoute + "get/all",
    getOneWordType: wordTypeRoute + "get/one",
    postOneWordType: wordTypeRoute + "create_or_update",

    // Topic
    deleteTopic: topicRoute + "delete",
    getAllTopic: topicRoute + "get/all",
    getOneTopic: topicRoute + "get/one",
    postOneTopic: topicRoute + "create_or_update",

    // Permission
    deletePermission: permissionRoute + "delete",
    getAllPermission: permissionRoute + "get/all",
    getOnePermission: permissionRoute + "get/one",
    postOnePermission: permissionRoute + "create_or_update",
    
}

class API {

    // getAll
    

    async getStorageInfo(query) {
        return await getRequest(route.getStorageInfo, query);
    }

    async getBuildUpdate(query) {
        return await getRequest(route.build_update, query);
    }

    // user
    async getAllUsers(query) {
        return await getRequest(`${route.getAllUsers}?${query}` );
    }
    async getOneUser(query) {
        return await getRequest(route.getOneUser, query)
    }
    async postUser(query) {
        return await postRequest(route.postUser, query)
    }
    // async approveUser(user_id) {
    //     return await postRequest(route.postUser, {
    //         id: user_id,
    //         approve: 1
    //     })
    // }
    async approveUser(query) {
        return await postRequest(route.postUser, query)
    }
    async resetUser(query) {
        return await postRequest(route.resetUser, query)
    }
    async postDeleteUser(query) {
        return await postRequest(route.deleteUser, query)
    }

    async postBlockUser(query) {
        return await postRequest(route.blockUser, query)
    }

    // user Result
    async getAllUsersTestResult(query) {
        return await getRequest(`${route.getAllUsersTestResult}?${query}` );
    }
    async getOneUserTestResult(query) {
        return await getRequest(route.getOneUserTestResult, query)
    }


    // question
    async getAllQuestions(query) {
        return await getRequest(route.getAllQuestions, query);
    }
    async getOneQuestion(query) {
        return await getRequest(route.getOneQuestion, query)
    }
    async postQuestion(query) {
        return await postRequest(route.postQuestion, query)
    }

    async updateTestQuestion(data) {
        return await postRequest(route.updateTestQuestion, data)
    }

    async postDeleteQuestion(query) {
        return await postRequest(route.deleteQuestion, query)
    }

    // async getAllCategory(query) {
    //     return await getRequest(route.getAllCategory, query)
    // }

    // category
    async getAllCategory(query) {
        return await getRequest(route.getAllCategory, query)
    }
    async getOneCategory(query) {
        return await getRequest(route.getOneCategory, query)
    }
    async postOneCategory(query) {
        return await postRequest(route.postOneCategory, query)
    }

    // blind test
    async getAllBlindTest(query) {
        return await getRequest(route.getAllBlindTest, query)
    }
    async getOneBlindTest(query) {
        return await getRequest(route.getOneBlindTest, query)
    }
    async postDeleteBlindTest(query) {
        return await postRequest(route.deleteBlindTest, query)
    }
    async postOneBlindTest(query) {
        return await postRequest(route.postOneBlindTest, query)
    }

    // Daily Task
    async getAllDailyTask(query) {
        return await getRequest(route.getAllDailyTask, query)
    }
    async getOneDailyTask(query) {
        return await getRequest(route.getOneDailyTask, query)
    }
    async postDeleteDailyTask(query) {
        return await postRequest(route.deleteDailyTask, query)
    }
    async postOneDailyTask(query) {
        return await postRequest(route.postOneDailyTask, query)
    }

    // Apply Leave Reason
    async getAllApplyLeaveReason(query) {
        return await getRequest(route.getAllApplyLeaveReason, query)
    }
    async getOneApplyLeaveReason(query) {
        return await getRequest(route.getOneApplyLeaveReason, query)
    }
    async postDeleteApplyLeaveReason(query) {
        return await postRequest(route.postDeleteApplyLeaveReason, query)
    }
    async postOneApplyLeaveReason(query) {
        return await postRequest(route.postOneApplyLeaveReason, query)
    }

    // Apply Leave Reason

    async getAllApplyLeave(query) {
        return await getRequest(route.getAllApplyLeave, query)
    }
    async getOneApplyLeave(query) {
        return await getRequest(route.getOneApplyLeave, query)
    }
    async postDeleteApplyLeave(query) {
        return await postRequest(route.postOneApplyLeave, query)
    }
    async postOneApplyLeave(query) {
        return await postRequest(route.postOneApplyLeave, query)
    }

    // folder
    async getAllFolder(query) {
        return await getRequest(route.getAllFolder, query)
    }
    async getOneFolder(query) {
        return await getRequest(route.getOneFolder, query)
    }
    async postDeleteFolder(query) {
        return await postRequest(route.deleteFolder, query)
    }
    async postOneFolder(query) {
        return await postRequest(route.postOneFolder, query)
    }

    // topic
    async getAllTopic(query) {
        return await getRequest(route.getAllTopic, query)
    }
    async getOneTopic(query) {
        return await getRequest(route.getOneTopic, query)
    }
    async postDeleteTopic(query) {
        return await postRequest(route.deleteTopic, query)
    }
    async postOneTopic(query) {
        return await postRequest(route.postOneTopic, query)
    }

    // class
    async getAllClass(query) {
        return await getRequest(route.getAllClass, query)
    }
    async getOneClsss(query) {
        return await getRequest(route.getOneClass, query)
    }
    async postDeleteClass(query) {
        return await postRequest(route.deleteClass, query)
    }
    async postOneClass(query) {
        return await postRequest(route.postOneClass, query)
    }

    // group permissionRoute
    async getAllPermission(query) {
        
        return await getRequest(route.getAllPermission, query);
    }
    async postOnePermission(data) {
        return await postRequest(route.postOnePermission, data);
    }
    async postDeletePermission(query) {
        return await postRequest(route.deletePermission, query)
    }
    async getOnePermission(query) {
        return await getRequest(route.getOnePermission, query)
    }

    // branchRoute
    async getAllBranch(query) {
        return await getRequest(route.getAllBranch, query);
    }
    async postOneBranch(data) {
        return await postRequest(route.postOneBranch, data);
    }
    async postDeleteBranch(query) {
        return await postRequest(route.deleteBranch, query)
    }
    async getOneBranch(query) {
        return await getRequest(route.getOneBranch, query)
    }

    // Word Type
    async getAllWordType(query) {
        return await getRequest(route.getAllWordType, query);
    }
    async postOneWordType(data) {
        return await postRequest(route.postOneWordType, data);
    }
    async postDeleteWordType(query) {
        return await postRequest(route.deleteWordType, query)
    }
    async getOneWordType(query) {
        return await getRequest(route.getOneWordType, query)
    }

    // word list
    async getAllWordList(query) {
        return await getRequest(route.getAllWordList, query);
    }
    async postOneWordList(data) {
        return await postRequest(route.postOneWordList, data);
    }
    async postDeleteWordList(query) {
        return await postRequest(route.deleteWordList, query)
    }
    async getOneWordList(query) {
        return await getRequest(route.getOneWordList, query)
    }

    // permission
    async getAllRole() {
        return await getRequest(route.getAllRole);
    }
    async getUserRole() {
        return await getRequest(route.getUserRole);
    }
    async createOrUpdateRole(data) {
        return await postRequest(route.createOrUpdateRole, data);
    }
    async createOrUpdatePermission(data) {
        
        return await postRequest(route.createOrUpdatePermission, data);
    }

    async getTerm(query) {
        return await getRequest(route.getTerm, query)
    }

    async getAbout(query) {
        return await getRequest(route.getAbout, query)
    }

    async adminUpload(query, onUploadProgress) {
        return await postImageRequest(adminUpload, query, onUploadProgress)
    }
    async updateSetting(query) {
        return await postRequest(route.updateSetting, query)
    }

    async login(data) {
        return await loginRequest(route.login, data)
    }

    getImage = () => {
        return serverURL + "/image/get/";
    }

    // post 

    
    

    // async publishVideo(query) {
    //     return await postRequest(route.publicVideo, query)
    // }

    // async postEpisode(query) {
    //     return await postRequest(route.postEpisode, query)
    // }

    

    

    

    

    // async postOneNews(query) {
    //     return await postRequest(route.postOneNews, query)
    // }
    // async getAllNews(query) {
    //     return await getRequest(route.getAllNews, query)
    // }
    // async getOneNews(query) {
    //     return await getRequest(route.getOneNews, query)
    // }

    // getOne

    

    

    // report

    // async getUsersReport(query) {
    //     return await getRequest(route.getUsersReport, query);
    // }

    // async getVideosReport(query) {
    //     return await getRequest(route.getVideosReport, query);
    // }

    // async getSellReport(query) {
    //     return await getRequest(route.getSellReport, query);
    // }

    
}


export default new API();

// export const getOneCategory = async (query) => {
//     console.log(route.getOneCategory, query)
//     return await getRequest(route.getOneCategory, query)
// }

// export const getOneNew = async (query) => {
//     console.log(route.getOneCategory, query)
//     return await getRequest(route.getOneCategory, query)
// }

// export const getOneUser = async (query) => {
//     console.log(route.getOneUser, query)
//     return await getRequest(route.getOneUser, query)
// }

export const login = async (data) => {
    return await postRequest(route.login, data)
}

